var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"b7470284df129a00d644d023156c6ffa457e4bb6"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["candidate-app-v2@migrate"]={id:"b7470284df129a00d644d023156c6ffa457e4bb6"};
      